import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** False when the environment variables are missing. The app then shows a
 *  configuration screen instead of a white page - a blank screen on a
 *  tablet at the face tells nobody anything. */
export const isConfigured = Boolean(url && anonKey);

if (!isConfigured) {
  console.error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
      'Copy .env.example to .env.local, or set them in the Netlify site settings.',
  );
}

/**
 * The browser only ever carries the anon key. Row-level security is the
 * security boundary - never ship the service_role key to the client.
 *
 * Sessions persist in localStorage via supabase-js; the refresh token is
 * long-lived so a tablet that has been offline for days still syncs on
 * return without a re-login at the face.
 */
export const supabase: SupabaseClient = createClient(
  url || 'http://localhost:54321',
  anonKey || 'missing-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: 'quarry.auth',
    },
    global: {
      headers: { 'x-application-name': 'quarry-management' },
    },
    db: { schema: 'public' },
  },
);

export const SITE_CODE = (import.meta.env.VITE_SITE_CODE as string) ?? 'SUREMIX';
